'use strict';

var moment = require('moment-timezone'),
    DateUtils,
    {forEach, includes} = require('lodash/collection'),
    DATE_FORMAT = require('../constants/AppConstants').DATE_FORMAT,
    DATE_FORMAT_DISPLAY = require('../constants/AppConstants').DATE_FORMAT_DISPLAY,
    DATE_FORMAT_SHORT = require('../constants/AppConstants').DATE_FORMAT_SHORT,
    DEFAULT_MONTH_BEFORE = require('../constants/AppConstants').DEFAULT_MONTH_BEFORE,
    DEFAULT_MONTH_AFTER = require('../constants/AppConstants').DEFAULT_MONTH_AFTER;

DateUtils = {
    /**
     * From a certain date and certain amount of days to increment, calculates the new date.
     * @argument {Date} date the date reference
     * @argument {Number} days number of days that will increment from date reference
     * @return {String} the calculdated date.
     */
    addDaysText(date, days, format = DATE_FORMAT_DISPLAY) {
        if (typeof date === 'string') {
            return moment(this.toDate(date)).add(days, 'days').format(format);
        } else {
            return moment(date).add(days, 'days').format(format);
        }
    },


    getByDateFromNowInDays(amountDays) {
        return moment().add(amountDays, 'days').format(DATE_FORMAT);
    },

    /**
     * From a certain date and certain amount of days to increment, calculates the new date.
     * @argument {Date} date the date reference
     * @argument {Number} days number of days that will increment from date reference
     * @return {String} the calculdated date.
     */
    addDaysTextBasicFormat(date, days) {
        if (typeof date === 'string') {
            return moment(this.toDate(date)).add(days, 'days').format(DATE_FORMAT);
        } else {
            return moment(date).add(days, 'days').format(DATE_FORMAT);
        }
    },

    /**
     * From a certain date and certain amount of days to increment, calculates the new date.
     * @argument {Date} date the date reference
     * @argument {Number} days number of days that will increment from date reference
     * @return {Date} the calculdated date
     */
    addDays(date, days) {
        if (typeof date === 'string') {
            // convert to Date obj and call myself
            return this.addDays(this.toDate(date), days);
        } else {
            return new Date(this.addDaysText(date, days));
        }
    },

    /**
     * Ask if the given date is before to day.
     * @argument {String} currentDate to validate
     * @argument {String} date to validate
     * @return {Boolean}
     */
    isBeforeToDay(date) {
        if (typeof date === 'string') {
            return moment().unix() > moment(date, DATE_FORMAT).unix();
        } else {
            return moment().unix() > moment(this.toDateText(date), DATE_FORMAT).unix();
        }
    },

    /**
     * Ask if the given date is after to day.
     * @argument {String} date to validate
     * @return {Boolean}
     */
    isAfterToDay(date) {
        return !this.isBeforeToDay(date);
    },
    
    isAfterOrEqualsToDay(date) {
        return  DateUtils.getToDayText() === date || !this.isBeforeToDay(date);
    },
    
    isBeforeOrEqualsToDay(date) {
        return  DateUtils.getToDayText() === date || this.isBeforeToDay(date);
    },

    isAfterToDayFullDate(date) {
        return  moment().unix() < moment(date).unix();
    },

    /**
     * Ask if the given date is after to another date defined.
     * @argument {String} dateCompare to that will be validate
     * @argument {String} date to that will be validate
     * @return {Boolean}
     */
    isAfter(dateCompare, date) {
        const isFullFormat = dateCompare && includes(dateCompare, 'T');
        if (isFullFormat ){
            return moment(dateCompare).unix() > moment(date).unix();
        } else {
            return moment(dateCompare, DATE_FORMAT).unix() > moment(date, DATE_FORMAT).unix();
        }
    },
    
    removeZulu(date) {
        if (date.indexOf('Z')) {
            return date.substring(0, date.length - 1);
        } else {
            return date;
        }
    },

    /**
     * Ask if the given date is after or equals to another date defined.
     * @argument {String} dateCompare to that will be validate
     * @argument {String} date to that will be validate
     * @return {Boolean}
     */
    isAfterOrEquals(dateCompare, date) {
        if (dateCompare === date) {
            return true;
        }
        return this.isAfter(dateCompare, date);
    },

    /**
     * Ask if the given date is before to another date defined.
     * @argument {String} dateCompare to that will be validate
     * @argument {String} date to that will be validate
     * @return {Boolean}
     */
    isBefore(dateCompare, date) {
        return !this.isAfter(dateCompare, date) && !this.isEqual(dateCompare, date);
    },

    /**
     * Ask if the given date is before to another date defined.
     * @argument {String} dateCompare to that will be validate
     * @argument {String} date to that will be validate
     * @return {Boolean}
     */
    isBeforeOrEquals (dateCompare, date) {
        if (dateCompare === date) {
            return true;
        }
        return !this.isAfter(dateCompare, date) && !this.isEqual(dateCompare, date);
    },

    /**
     * Compare if both dates are equals with each other.
     * @argument {String} dateOne the date will be comper agains to dateTwo.
     * @argument {String} dateTwo the date will be comper agains to dateOne.
     * @return {Boolean}
     */
    isEqual(dateOne, dateTwo) {
        return moment(dateOne, DATE_FORMAT).format(DATE_FORMAT) === moment(dateTwo, DATE_FORMAT).format(DATE_FORMAT);
    },

    incrementByDays(currentDate, oldFrom, oldTo, days) {
        const date = this.toDateText(this.addDays(this.toDate(currentDate), days));
        const from = this.toDateText(this.addDays(this.toDate(oldFrom), days));
        const to = this.toDateText(this.addDays(this.toDate(oldTo), days));

        return {
            from,
            to,
            date
        };
    },

    incrementByMonths(currentDate, months) {
        var newCurrentDate = moment(currentDate, DATE_FORMAT).add(months, 'month').format(DATE_FORMAT),
            rangeFrom = moment(newCurrentDate, DATE_FORMAT).subtract(DEFAULT_MONTH_BEFORE, 'month').format(DATE_FORMAT),
            rangeTo = moment(newCurrentDate, DATE_FORMAT).add(DEFAULT_MONTH_AFTER, 'month').format(DATE_FORMAT);
        return {
            from: rangeFrom,
            to: rangeTo,
            date: newCurrentDate
        };
    },

    /**
     * Validate if given date text is the first day of the current month.
     * @param {String} dateText
     * @returns {boolean}
     */
    isFirstDayOfCurrentMonth(dateText) {
        var dateToValidate = moment(this.toDateText(dateText), DATE_FORMAT);

        if (moment(dateToValidate).format('MMMM') === this.getCurrentMonth() &&
            moment(dateToValidate).format('DD') === '01') { // first day of month
            return true;
        }
        return false;
    },

    /**
     * Retrieve the current mont.
     */
    getCurrentMonth() {
        return moment().format('MMMM');
    },
    
    getCurrentDate() {
        return moment().format();
    },
    
    getToDayText() {
        return moment().format(DATE_FORMAT);
    },

    /**
     * Retrieve is the given date is weekend or not.
     * @argument {String} date that will be validated.
     * @return {Boolean}
     */
    isWeekend(date) {
        var day = moment(date, DATE_FORMAT).day();
        return (day === 0 || day === 6);
    },
    /**
     * Retrieve is the given date is weekend or not.
     * @argument {String} date that will be validated.
     * @return {Boolean}
     */
    isMondayTuesdayOrWednesday(date) {
        var day = moment(date, DATE_FORMAT).day();
        return (day === 1 || day === 3 || day === 5);
    },
    /**
     * Retrieve is the given date is weekend or not.
     * @argument {String} date that will be validated.
     * @return {Boolean}
     */
    isSaturday(date) {
        var day = moment(date, DATE_FORMAT).day();
        return day === 6;
    },

    isToDay(date) {
        const isDateType = typeof date === 'object';
        if (isDateType) {
            return this.toDateText(date) === moment().format(DATE_FORMAT);
        }
        return date === moment().format(DATE_FORMAT);
    },

    /**
     * Retrieve is the given date is weekend or not.
     * @argument {String} date that will be validated.
     * @return {Boolean}
     */
    isSunday(date) {
        var day = moment(date, DATE_FORMAT).day();
        return day === 0;
    },

    /**
     * Convert date string to object.
     * @argument {String} date to ve converted Date object.
     * @return {Date}
     */
    toDate(date) {
        return new Date(moment(date, DATE_FORMAT).format(DATE_FORMAT_DISPLAY));
    },

    toDateFullText(date) {
        return moment(date).format();
    },

    toEndOfDate(date) {
        return moment(date).add(23, 'hours').add(59, 'minutes').format();
    },

    toStartOfDate(date) {
        return moment(date).startOf('day').format();
    },

    /**
     * Return the current date.
     * @return {String}
     */
    getNowDate() {
       return moment().format(DATE_FORMAT);
    },

    /**
     * Convert date string to object.
     * @argument {String} date DATE_FORMAT to ve converted Date object.
     * @argument {String} hours (HH:mm)         to ve converted Date object (HHmm).
     * @return {Date}
     */
    toDateAndHours(date, hours) {
        return moment(date + hours, DATE_FORMAT+'HH:mm').toDate();
    },

    toDateFromFullDate(date) {
        return new Date(date);
    },

    /**
     *
     * @param date
     * @return {*}
     */
    toHHMM(date) {
        return moment(date).format('HH:mm');
    },

    /**
     * Convert date string to object.
     * @argument {Date} date to ve converted Date object.
     * @return {String}
     */
    toDateText(date) {
        return moment(date).format(DATE_FORMAT);
    },

    /**
     * Convert date string to object.
     * @argument {Date} date to ve converted Date object.
     * @return {String}
     */
    toDateTextWithHHMM(date) {
        return moment(date).format('HH:mm');
    },

    /**
     * Convert date string to full string date format.
     * @argument {Date} date to ve converted to string date.
     * @return {String}
     */
    toFullDate(date) {
        return moment(date).format();
    },

    /**
     * Change to shorter date format.
     * @argument {String} date to be changed.
     * @return {String}
     */
    toShortDateText(date) {
        return moment(date, DATE_FORMAT).format(DATE_FORMAT_SHORT);
    },

    /**
     * Retrieve the day of the date.
     * @argument {String} date to be changed
     * @return {String}
     */
    toDayText(date) {
        return moment(date, DATE_FORMAT).format('DD');
    },

    /**
     * Convert date to properly display date.
     * @argument {Date} date the display that will be converted.
     */
    toDisplayDateText(date) {
        return moment(date).format('MMMM DD');
    },

    /**
     * Convert date to properly display date.
     * @argument {Date} date the display that will be converted.
     */
    toDisplayDateTextShort(date) {
        return moment(date).format('MMM DD');
    },

    /**
     * Convert date to properly display date.
     * @argument {Date} date the display that will be converted.
     */
    toDisplayMonthText(date) {
        return moment(this.toDate(date)).format('MMMM');
    },

    /**
     * Convert date to properly display date.
     * @argument {Date} date the display that will be converted.
     */
    toYYYYMMDDhhmm(date) {
        return moment(date).format(DATE_FORMAT + ' HH:mm');
    },

    /**
     * Convert date to properly display date.
     * @argument {Date} date the display that will be converted.
     */
    toDisplayMonthTextShort(date) {
        return moment(this.toDate(date)).format('MMM');
    },

    /**
     * Retrieve the amount of days between current dashboard date range.
     * @returns {Number}
     */
    getDaysBetween(dateFrom, dateTo) {
        let dateFromText, dateToText;

        if (typeof dateFrom === 'string') {
            dateFromText = dateFrom;
        } else {
            dateFromText = this.toDateText(dateFrom);
        }

        if (typeof dateTo === 'string') {
            dateToText = dateTo;
        } else {
            dateToText = this.toDateText(dateTo);
        }

        return moment(dateToText, DATE_FORMAT).diff(moment(dateFromText, DATE_FORMAT), 'days');
    },

    /**
     * Retrieve the amount of days between dates.
     * @param {Date} dateFrom
     * @param {Date} dateTo
     * @return {number}
     */
    getMinutesBetween(from, to) {
        return +moment.duration(moment(to).diff(from)).asMinutes();
    },

    /**
     * Ask if given date is between given range of dates.
     * @param {String} dateCompare
     * @param {String} from
     * @param {String} to
     * @return {Boolean}
     */
    isDateBetween(dateCompare, from, to) {
        let dateFromText, dateToText;

        if (typeof from === 'string') {
            dateFromText = from;
        } else {
            dateFromText = this.toDateText(from);
        }

        if (typeof to === 'string') {
            dateToText = to;
        } else {
            dateToText = this.toDateText(to);
        }

        return this.isAfterOrEquals(dateCompare, dateFromText) && this.isBeforeOrEquals(dateCompare, dateToText);
    },

    /**
     * Retrieve the earlt date given an arrays of dates.
     * @arguments {String} dates with formant
     */
    getEarlyDate(dates) {
        let earlyDate;
        if (dates && dates.length) {
            earlyDate = dates[0];
            forEach(dates, date => {
                if (this.isBefore(earlyDate, date)) {
                    earlyDate = date;
                }
            });
            return earlyDate;
        }
    },

    /**
     * Sort given list of dates by field and date.
     * @param lists
     * @param field
     * @return {Array}
     */
    sortListByDateField(lists, field) {
        if (lists) {
            return (lists || []).sort((a, b) => {
                if (this.isAfter(a[field], b[field])) {
                    return 1;
                }
                if (this.isBefore(a[field], b[field])) {
                    return -1;
                }
                return 0;
            });
        }
    },

    /**
     * Sort given list of dates by field and date on desc order.
     * @param lists
     * @param field
     * @return {Array}
     */
    sortListByDateFieldDesc(lists, field) {
        if (lists) {
            return (lists || []).sort((a, b) => {
                if (this.isAfter(a[field], b[field])) {
                    return -1;
                }
                if (this.isBefore(a[field], b[field])) {
                    return 1;
                }
                return 0;
            });
        }
    },

    /**
     * Convert date text to current applicant timezone.
     *
     * @param String dateText example a valid format date (eg:'2017-09-13T20:01:11.346Z').
     * @Param String timeZone   (optionally) A properly time-zone format (eg: 'America/New_York').
     * @Param String formatDate (optionally) A format date (eg: 'YYYY-MM-DD HH:mm').
     */
    toCurrentTimeZone(date, timeZone, formatDate) {
        if (date) {
            return moment.tz(date, timeZone || 'America/Denver').format(formatDate || DATE_FORMAT +' HH:mm');
        }
    }
};


module.exports = DateUtils;



/** WEBPACK FOOTER **
 ** ./src/utils/DateUtils.js
 **/